import React from 'react'
import { Box, Button, Paper, Typography } from '@material-ui/core'
import mapVisitorWarningStyles from './mapVisitorWarningStyles'
import { getShowVisitorLabel } from '../../../../../../../utils/utils'

function MapVisitorWarning({ selectedFilters }) {
  const classes = mapVisitorWarningStyles()
  const [showVisitorWarning, setShowVisitorWarning] = React.useState(false)
  const handleRedirectToLogin = () => {
    localStorage.setItem('loginRedirect', '/maps')
    window.location.href = process.env.REACT_APP_LOGIN_LINK
  }
  React.useEffect(() => {
    // check localStorage to determine if a user is logged in
    const redirectToMaps = getShowVisitorLabel()
    if (redirectToMaps && selectedFilters.includes('permit')) {
      setShowVisitorWarning(true)
    } else {
      setShowVisitorWarning(false)
    }
  }, [selectedFilters])
  if (!showVisitorWarning) return null
  return (
    <Box className={classes.mapVisitorParent}>
      <Box className={classes.mapVisitorRelativeContainer}>
        <Box component={Paper} className={classes.mapVisitorWarningContainer}>
          <Typography variant="subtitle">
            To view parking lots authorized by your parking permit, log in with
            your NetID using the button below.
          </Typography>
          <Button
            onClick={handleRedirectToLogin}
            className={classes.mapVisitorButton}
          >
            Login
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default MapVisitorWarning
